module.exports = __webpack_public_path__ + "static/media/product_640-2.da0b0457.jpg";